import { ClipboardList } from "lucide-react";
import TareasPanel from "../../components/TareasPanel";

// Fix EM (2026-09-28): "al módulo de ingeniería le falta su apartado de TAREAS que
// correspondan a ese módulo" (CEN). Son las tareas de Gabinete (Ingeniería y
// Presupuestos, Fix CR), como la pestaña Tareas de Compras, RRHH o Inventario.
export default function TareasIngenieria() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6 min-h-full" data-testid="ingenieria-tareas-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight flex items-center gap-2">
          <ClipboardList size={26} className="text-[#8B5CF6]" /> Tareas
        </h1>
        <p className="text-sm text-gray-500 mt-0.5">Tareas de Ingeniería y Presupuestos</p>
      </div>
      <TareasPanel modulo="gabinete" titulo="Tareas y Flujo de Trabajo — Ingeniería" />
    </div>
  );
}
